import type { PortableTextComponentProps } from '@portabletext/react';
import * as style from './SkyraSurvey.module.css';

export default function SkyraSurvey({ value }: PortableTextComponentProps<{ slug: string }>) {
    return <skyra-survey className={style.skyraSurvey} slug={value.slug} role="complementary" />;
}
